// @flow
import {
  ADMIN_GET_ALL_USERS,
  ADMIN_REMOVE_USER_ITEM,
  ADMIN_GET_ALL_GROUPS,
  ADMIN_APPEND_USER_DATA,
  ADMIN_GET_COMPANY_FACEBASE,
  ADMIN_UPDATE_USER_LIST,
  ADMIN_GET_GROUP_USERS
} from "../../global/actions/actionNames";

import { propComparator } from "../../global/functions/StringOperations";

const initialState = {
  users: null,
  groups: null,
  companies: null,
  facebases: null,
  groupUsers: null
};

const userReducers = (state: Object = initialState, actions: Object): * => {
  switch (actions.type) {
    case ADMIN_GET_ALL_USERS:
      if (actions.users !== null) {
        const users = {...actions.users};
        return {
          ...state,
          users: users
        };
      }
      return state;

    case ADMIN_GET_GROUP_USERS:
      if (actions.users !== null) {
        const users = {...actions.users};
        return {
          ...state,
          groupUsers: users
        };
      }
      return state;

    case ADMIN_REMOVE_USER_ITEM:
      if (actions.userId !== null && state.users !== null) {
        let users = { ...state.users };
        delete users[actions.userId];

        return {
          ...state,
          users: users
        };
      }
      return state;

    case ADMIN_GET_ALL_GROUPS:
      if (actions.groups !== null) {
        const groups = actions.groups;
        groups.sort(propComparator("name", true));
        return {
          ...state,
          groups: groups
        };
      }
      return state;

    case ADMIN_APPEND_USER_DATA:
      if (actions.field !== null && actions.userId !== null) {
        let users = { ...state.users };
        let user = { ...users[actions.userId] };
        user[actions.field] = actions.data;
        users[actions.userId] = user;
        return {
          ...state,
          users: users
        };
      }
      return state;

    case ADMIN_GET_COMPANY_FACEBASE:
      if (actions.companies !== null) {
        const companies = actions.companies;
        companies.sort(propComparator("name", true));

        let facebases = [];
        companies.map((company: *) => {
          let companyFacebases = [...company.facebases.edges];
          companyFacebases.map((facebase: *) => {
            let facebaseItem = { ...facebase.node };
            facebaseItem.company = { id: company.id, name: company.name };
            facebases.push(facebaseItem);
          });
        });
        facebases.sort(propComparator("company", true, "name"));

        return {
          ...state,
          companies: companies,
          facebases: facebases
        };
      }
      return state;

    case ADMIN_UPDATE_USER_LIST:
      if (actions.user !== null) {
        let users = { ...state.users };
        users[actions.user.uuid] = actions.user;

        return {
          ...state,
          users: users
        };
      }
      return state;

    default:
      return state;
  }
};
export default userReducers;
